"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

var _taggedTemplateLiteralLoose = require("@babel/runtime/helpers/taggedTemplateLiteralLoose");

var _templateObject, _templateObject2, _templateObject3;

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __name = function __name(target, value) {
  return __defProp(target, "name", {
    value: value,
    configurable: true
  });
};

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _loop = function _loop() {
      var key = _step2.value;
      if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
        get: function get() {
          return from[key];
        },
        enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
      });
    };

    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropNames(from)), _step2; !(_step2 = _iterator2()).done;) {
      _loop();
    }
  }

  return to;
};

var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps( // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/index.ts


var src_exports = {};

__export(src_exports, {
  Breakpoints: function Breakpoints() {
    return _Breakpoints;
  },
  ColorMode: function ColorMode() {
    return _ColorMode;
  },
  GlobalStyle: function GlobalStyle() {
    return _GlobalStyle;
  },
  MaestroThemeProvider: function MaestroThemeProvider() {
    return _MaestroThemeProvider;
  },
  __DEV__: function __DEV__() {
    return _DEV__;
  },
  __TEST__: function __TEST__() {
    return _TEST__;
  },
  baseUnit: function baseUnit() {
    return _baseUnit;
  },
  border: function border() {
    return _border;
  },
  breakpoint: function breakpoint() {
    return _breakpoint;
  },
  canUseDOM: function canUseDOM() {
    return _canUseDOM;
  },
  color: function color() {
    return _color;
  },
  component: function component() {
    return _component;
  },
  defaultTheme: function defaultTheme() {
    return _defaultTheme;
  },
  fontSize: function fontSize() {
    return _fontSize;
  },
  fontWeight: function fontWeight() {
    return _fontWeight;
  },
  get: function get() {
    return _get;
  },
  isBrowser: function isBrowser() {
    return _isBrowser;
  },
  isFunction: function isFunction() {
    return _isFunction;
  },
  lineHeight: function lineHeight() {
    return _lineHeight;
  },
  opacity: function opacity() {
    return _opacity;
  },
  palette: function palette() {
    return _palette;
  },
  radius: function radius() {
    return _radius;
  },
  setTheme: function setTheme() {
    return _setTheme;
  },
  shadow: function shadow() {
    return _shadow;
  },
  spacing: function spacing() {
    return _spacing;
  },
  stripUnit: function stripUnit() {
    return _stripUnit;
  },
  themeMode: function themeMode() {
    return _themeMode;
  },
  token: function token() {
    return _token;
  },
  useEnhancedEffect: function useEnhancedEffect() {
    return _useEnhancedEffect;
  },
  useStyles: function useStyles() {
    return _useStyles;
  },
  variant: function variant() {
    return _variant;
  },
  zIndex: function zIndex() {
    return _zIndex;
  }
});

module.exports = __toCommonJS(src_exports); // src/MaestroThemeProvider/MaestroThemeProvider.tsx

var import_react2 = __toESM(require("react"));

var import_styled_components3 = require("styled-components"); // src/themes/types.ts


var _Breakpoints;

(function (Breakpoints2) {
  Breakpoints2[Breakpoints2["xs"] = 320] = "xs";
  Breakpoints2[Breakpoints2["sm"] = 480] = "sm";
  Breakpoints2[Breakpoints2["ms"] = 600] = "ms";
  Breakpoints2[Breakpoints2["md"] = 768] = "md";
  Breakpoints2[Breakpoints2["ml"] = 960] = "ml";
  Breakpoints2[Breakpoints2["lg"] = 1024] = "lg";
  Breakpoints2[Breakpoints2["xl"] = 1280] = "xl";
  Breakpoints2[Breakpoints2["xxl"] = 1330] = "xxl";
  Breakpoints2[Breakpoints2["jb"] = 1440] = "jb";
})(_Breakpoints || (_Breakpoints = {})); // src/themes/defaultTheme.ts


var import_styled_components2 = require("styled-components"); // src/utils/assertions.ts


var _isFunction =
/* @__PURE__ */
__name(function (value) {
  return typeof value === "function";
}, "isFunction");

var _DEV__ = process.env.NODE_ENV !== "production";

var _TEST__ = process.env.NODE_ENV === "test"; // src/utils/theme.tsx


var import_react = require("react");

var import_styled_components = require("styled-components");

var import_css = __toESM(require("@styled-system/css"));

var import_polished = require("polished");

var _get =
/* @__PURE__ */
__name(function (obj, path, defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = null;
  }

  var result = String.prototype.split.call(path, /[,[\].]+?/).filter(Boolean).reduce(function (res, key) {
    return res !== null && res !== void 0 ? res[key] : res;
  }, obj);
  return result === void 0 || result === obj ? defaultValue : result;
}, "get");

var themeGet =
/* @__PURE__ */
__name(function (props, path) {
  var value = _get(props.theme, path);

  return _isFunction(value) ? value(props) : value;
}, "themeGet");

var _stripUnit =
/* @__PURE__ */
__name(function (str) {
  return parseFloat(str);
}, "stripUnit");

var _token =
/* @__PURE__ */
__name(function (path) {
  return function (props) {
    return themeGet(props, path);
  };
}, "token");

var _color =
/* @__PURE__ */
__name(function (path, opacity2) {
  if (opacity2 === void 0) {
    opacity2 = 1;
  }

  return function (props) {
    return (0, import_polished.rgba)(themeGet(props, "colors." + path), opacity2);
  };
}, "color");

var _opacity =
/* @__PURE__ */
__name(function (path) {
  return function (props) {
    return themeGet(props, "opacities." + path);
  };
}, "opacity");

var _palette = _color;

var _baseUnit =
/* @__PURE__ */
__name(function (multiplier) {
  return function (_ref) {
    var theme = _ref.theme;
    return theme.baseUnit(multiplier);
  };
}, "baseUnit");

var _spacing =
/* @__PURE__ */
__name(function (size, options) {
  return function (_ref2) {
    var theme = _ref2.theme;
    return theme.spacing(size, options);
  };
}, "spacing");

var _fontSize =
/* @__PURE__ */
__name(function (size) {
  return function (props) {
    return themeGet(props, "fontSizes." + size);
  };
}, "fontSize");

var _lineHeight =
/* @__PURE__ */
__name(function (size) {
  return function (props) {
    return themeGet(props, "lineHeights." + size);
  };
}, "lineHeight");

var _fontWeight =
/* @__PURE__ */
__name(function (weight) {
  return function (props) {
    return themeGet(props, "fontWeights." + weight);
  };
}, "fontWeight");

var _radius =
/* @__PURE__ */
__name(function (radius2) {
  return function (props) {
    return themeGet(props, "radii." + radius2);
  };
}, "radius");

var _shadow =
/* @__PURE__ */
__name(function (shadow2) {
  return function (props) {
    return themeGet(props, "shadows." + shadow2);
  };
}, "shadow");

var _component =
/* @__PURE__ */
__name(function (path) {
  return function (props) {
    return themeGet(props, "components." + path);
  };
}, "component");

var _border =
/* @__PURE__ */
__name(function (type) {
  return function (props) {
    return themeGet(props, "borders." + type);
  };
}, "border");

var _zIndex =
/* @__PURE__ */
__name(function (zIndex2) {
  return function (props) {
    return Number(themeGet(props, "zIndices." + zIndex2));
  };
}, "zIndex");

var _breakpoint =
/* @__PURE__ */
__name(function (breakpoint3) {
  return function (_ref3) {
    var theme = _ref3.theme;
    return theme.breakpoint(breakpoint3);
  };
}, "breakpoint");

var getThemeModeValue =
/* @__PURE__ */
__name(function (props, values) {
  var mode = props && props.theme && props.theme.mode;
  var themeValue = typeof mode === "function" ? mode(values) : values[mode];
  return typeof themeValue === "function" ? themeValue(props) : themeValue;
}, "getThemeModeValue");

var _themeMode =
/* @__PURE__ */
__name(function (values) {
  return function (props) {
    return getThemeModeValue(props, values);
  };
}, "themeMode");

var parseStyles =
/* @__PURE__ */
__name(function (styles) {
  return function (props) {
    if (!styles) {
      return;
    }

    return Object.entries(styles).reduce(function (acc, _ref4) {
      var key = _ref4[0],
          value = _ref4[1];

      if (typeof value === "object") {
        if (key in props && typeof props[key] === "boolean" && !!props[key]) {
          acc = __spreadValues(__spreadValues({}, acc), parseStyles(value)(props));
          return acc;
        }

        acc[key] = parseStyles(value)(props);
        return acc;
      }

      acc[key] = typeof value === "function" ? value(props) : value;
      return acc;
    }, {});
  };
}, "parseStyles");

var extractStyles =
/* @__PURE__ */
__name(function (props, variantValues, theme) {
  var variantStyles = typeof variantValues === "function" ? variantValues(props) : variantValues;
  var flattenedValues = parseStyles(variantStyles)(props);
  return (0, import_css.default)(flattenedValues)(theme);
}, "extractStyles");

var _variant =
/* @__PURE__ */
__name(function (_ref5) {
  var prop = _ref5.prop,
      compoundProp = _ref5.compoundProp,
      variants = _ref5.variants;
  return function (props) {
    var _a;

    var theme = props.theme;
    var compiledStyles = {};
    var propValue = props[prop];
    var variantValues = variants == null ? void 0 : variants[propValue];
    var extractedStyles = extractStyles(props, variantValues, theme);
    compiledStyles = __spreadValues(__spreadValues({}, compiledStyles), extractedStyles);

    if (compoundProp) {
      var compoundPropValue = props[compoundProp];
      var variantValues2 = (_a = variants == null ? void 0 : variants[propValue]) == null ? void 0 : _a[compoundPropValue];
      var extractedStyles2 = extractStyles(props, variantValues2, theme);
      compiledStyles = __spreadValues(__spreadValues({}, compiledStyles), extractedStyles2);
    }

    var finalStyles = Object.entries(compiledStyles).reduce(function (acc, _ref6) {
      var key = _ref6[0],
          value = _ref6[1];
      var x = _isFunction(value) ? value(props) : value;
      acc[key] = x;
      return acc;
    }, {});
    var finalCompileStyles = (0, import_css.default)(finalStyles)(theme);
    return finalCompileStyles;
  };
}, "variant");

var _useStyles =
/* @__PURE__ */
__name(function (_ref7) {
  var styles = _ref7.styles,
      props = _ref7.props;
  var themeContext = (0, import_react.useContext)(import_styled_components.ThemeContext);
  return styles(__spreadValues({
    theme: themeContext
  }, props));
}, "useStyles"); // src/themes/defaultTheme.ts


var baseFontSize = "15px";
var containers = {
  xs: "320px",
  sm: "480px",
  ms: "600px",
  md: "768px",
  ml: "960px",
  lg: "1024px",
  xl: "1280px",
  xxl: "1330px",
  jb: "1440px"
};
var BASE_UNIT = 4;

var BASE_UNIT_REM = 4 / _stripUnit(baseFontSize);

var baseUnit2 =
/* @__PURE__ */
__name(function (multiplier) {
  return multiplier * BASE_UNIT + "px";
}, "baseUnit");

var space = {
  none: baseUnit2(0),
  xxs: baseUnit2(1),
  xs: baseUnit2(2),
  sm: baseUnit2(3),
  md: baseUnit2(4),
  lg: baseUnit2(5),
  xl: baseUnit2(6),
  xxl: baseUnit2(9),
  jb: baseUnit2(12),
  mg: baseUnit2(18)
};

var spacing2 =
/* @__PURE__ */
__name(function (amount, options) {
  var unitless = options && options.unitless;

  if (amount === "auto") {
    return amount;
  }

  if (typeof amount === "string" && amount in space) {
    return unitless ? _stripUnit(space[amount]) : space[amount];
  }

  var value = amount;
  return unitless ? _stripUnit(baseUnit2(value)) : baseUnit2(value);
}, "spacing");

var fontFamily = {
  base: "'Sailec', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'"
};
var fontSizes = {
  xs: "0.7333334rem",
  sm: "0.8666667rem",
  base: "1rem",
  md: "1rem",
  lg: "1.2rem",
  xl: "1.6rem",
  xxl: "2rem",
  xxxl: "2.4rem",
  jb: "3.2rem",
  mg: "4rem"
};
var fontWeights = {
  light: 300,
  regular: 400,
  bold: 700,
  extrabold: 900
};
var lineHeights = {
  xs: baseUnit2(4),
  sm: baseUnit2(5),
  base: baseUnit2(6),
  md: baseUnit2(6),
  lg: baseUnit2(7),
  xl: baseUnit2(9),
  xxl: baseUnit2(10),
  xxxl: baseUnit2(13),
  jb: baseUnit2(15),
  mg: baseUnit2(16)
};
var breakpoints = [_Breakpoints.xs + "px", _Breakpoints.sm + "px", _Breakpoints.ms + "px", _Breakpoints.md + "px", _Breakpoints.ml + "px", _Breakpoints.lg + "px", _Breakpoints.xl + "px", _Breakpoints.xxl + "px", _Breakpoints.jb + "px"];
breakpoints["xs"] = breakpoints[0];
breakpoints["sm"] = breakpoints[1];
breakpoints["ms"] = breakpoints[2];
breakpoints["md"] = breakpoints[3];
breakpoints["ml"] = breakpoints[4];
breakpoints["lg"] = breakpoints[5];
breakpoints["xl"] = breakpoints[6];
breakpoints["xxl"] = breakpoints[7];
breakpoints["jb"] = breakpoints[8];

var breakpoint2 =
/* @__PURE__ */
__name(function (breakpoint3, direction) {
  if (breakpoint3 === void 0) {
    breakpoint3 = "md";
  }

  if (direction === void 0) {
    direction = "down";
  }

  return function (literals) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return import_styled_components2.css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n            @media (", "-width: ", ") {\n                ", "\n            }\n        "])), direction === "down" ? "max" : "min", breakpoints[breakpoint3], (0, import_styled_components2.css).apply(void 0, [literals].concat(args)));
  };
}, "breakpoint");

var radii = {
  sm: "2px",
  base: "4px",
  lg: "8px",
  round: "100rem"
};
var palette2 = {
  primary: {
    300: "#84dfdf",
    400: "#5ad5d5",
    500: "#32cbcb",
    600: "#2db6b6",
    700: "#28a2a2"
  },
  secondary: {
    300: "#3c6ed7",
    400: "#245dd2",
    500: "#0c4bce",
    600: "#0a43b9",
    700: "#093ca4"
  },
  neutral: {
    0: "#ffffff",
    50: "#f9fafb",
    100: "#f4f6f8",
    200: "#dfe3e9",
    300: "#c5cdd5",
    400: "#adb7bf",
    500: "#6c7782",
    600: "#5a6774",
    700: "#435261",
    800: "#2c3c4d",
    900: "#142739",
    1e3: "#0c1b2b"
  },
  danger: {
    300: "#ea5b70",
    400: "#e7435c",
    500: "#e11534",
    600: "#ca122e",
    700: "#b41029"
  },
  warning: {
    300: "#f6e07f",
    400: "#f3d44c",
    500: "#eec200",
    600: "#eab102",
    700: "#dba602"
  },
  success: {
    300: "#84dfdf",
    400: "#5ad5d5",
    500: "#32cbcb",
    600: "#2db6b6",
    700: "#28a2a2"
  },
  facebook: {
    500: "#4267b2",
    700: "#35528e"
  },
  twitter: {
    500: "#00aced",
    700: "#008abe"
  },
  bronze: {
    300: "#BF8A59",
    400: "#A66F40",
    500: "#875733",
    600: "#5E3F22",
    700: "#3A2912"
  },
  silver: {
    300: "#B7BDC8",
    400: "#9CA4AF",
    500: "#7D8794",
    600: "#68707E",
    700: "#505663"
  },
  gold: {
    300: "#BFB58B",
    400: "#AD9E6C",
    500: "#A3905B",
    600: "#74683F",
    700: "#534D2C"
  },
  platinum: {
    0: "#ffffff",
    50: "#f9fafb",
    100: "#f4f6f8",
    200: "#dfe3e9",
    300: "#c5cdd5",
    400: "#adb7bf",
    500: "#6c7782",
    600: "#5a6774",
    700: "#435261",
    800: "#2c3c4d",
    900: "#142739",
    1e3: "#0c1b2b"
  }
};
var borders = {
  base: _themeMode({
    light: "1px solid " + palette2.neutral[300],
    dark: "1px solid " + palette2.neutral[600]
  }),
  hover: _themeMode({
    light: "1px solid " + palette2.neutral[500],
    dark: "1px solid " + palette2.neutral[400]
  }),
  subtle: _themeMode({
    light: "1px solid " + palette2.neutral[200],
    dark: "1px solid " + palette2.neutral[700]
  })
};

var colors = __spreadValues({
  text: {
    base: _themeMode({
      light: palette2.neutral[900],
      dark: palette2.neutral[50]
    }),
    // @deprecated: use `accent` instead
    high: _themeMode({
      light: palette2.primary[500],
      dark: palette2.primary[500]
    }),
    accent: _themeMode({
      light: palette2.primary[500],
      dark: palette2.primary[500]
    }),
    // @deprecated: use `subtle` instead
    low: _themeMode({
      light: palette2.neutral[500],
      dark: palette2.neutral[400]
    }),
    subtle: _themeMode({
      light: palette2.neutral[500],
      dark: palette2.neutral[400]
    }),
    muted: _themeMode({
      light: palette2.neutral[400],
      dark: palette2.neutral[500]
    }),
    inverted: _themeMode({
      light: palette2.neutral[0],
      dark: palette2.neutral[1e3]
    })
  },
  background: {
    base: _themeMode({
      light: palette2.neutral[0],
      dark: palette2.neutral[1e3]
    }),
    high: palette2.danger[500],
    low: palette2.danger[500]
  },
  border: {
    base: palette2.neutral[200],
    high: palette2.danger[500],
    low: palette2.danger[500]
  },
  surface: _themeMode({
    light: palette2.neutral[0],
    dark: palette2.neutral[800]
  })
}, palette2);

var shadows = {
  0: "none",
  1: "0 2px 4px 0 rgba(0, 0, 0, .04), 0 3px 4px 0 rgba(0, 0, 0, .04), 0 1px 5px 0 rgba(0, 0, 0, .08)",
  2: "0 6px 10px 0 rgba(0, 0, 0, .04), 0 1px 18px 0 rgba(0, 0, 0, .04), 0 3px 5px 0 rgba(0, 0, 0, .08)",
  3: "0 12px 17px 2px rgba(0, 0, 0, .04), 0 5px 22px 4px rgba(0, 0, 0, .04), 0 7px 8px 0 rgba(0, 0, 0, .08)"
};
var components = {};
var modes = ["light", "dark"];
var defaultMode = modes[1];
var zIndices = {
  absoluteTop: 2147483638,
  alert: 4e3,
  modal: 3e3,
  overlay: 2e3,
  subOverlay: 1e3,
  base: 0
};
var opacities = {
  invisible: 0,
  transparent: 0.16,
  shadow: 0.32,
  subtle: 0.48,
  translucent: 0.64,
  overlay: 0.8,
  opaque: 1
};
var _defaultTheme = {
  BASE_UNIT: BASE_UNIT,
  BASE_UNIT_REM: BASE_UNIT_REM,
  baseUnit: baseUnit2,
  containers: containers,
  spacing: spacing2,
  space: space,
  palette: palette2,
  colors: colors,
  fontFamily: fontFamily,
  fontSizes: fontSizes,
  fontWeights: fontWeights,
  baseFontSize: baseFontSize,
  lineHeights: lineHeights,
  breakpoints: breakpoints,
  breakpoint: breakpoint2,
  borders: borders,
  radii: radii,
  shadows: shadows,
  components: components,
  modes: modes,
  defaultMode: defaultMode,
  zIndices: zIndices,
  opacities: opacities
}; // src/MaestroThemeProvider/MaestroThemeProvider.tsx

var _MaestroThemeProvider =
/* @__PURE__ */
__name(function (_ref8) {
  var _ref8$theme = _ref8.theme,
      theme = _ref8$theme === void 0 ? _defaultTheme : _ref8$theme,
      _ref8$mode = _ref8.mode,
      mode = _ref8$mode === void 0 ? "dark" : _ref8$mode,
      children = _ref8.children;
  return (
    /* @__PURE__ */
    import_react2.default.createElement(import_styled_components3.ThemeProvider, {
      theme: __spreadProps(__spreadValues({}, theme), {
        mode: mode
      })
    }, children)
  );
}, "MaestroThemeProvider");

_MaestroThemeProvider.displayName = "Maestro.ThemeProvider"; // src/MaestroThemeProvider/ColorMode.tsx

var import_react3 = __toESM(require("react"));

var import_styled_components4 = require("styled-components");

var _setTheme =
/* @__PURE__ */
__name(function (modeOption) {
  return function (theme) {
    if (!theme || theme && !theme.mode) {
      throw new Error("The `ColorMode` component expected a theme with a mode property but none was provided.");
    }

    var mode = theme.mode;

    switch (modeOption) {
      case "light":
        mode = "light";
        break;

      case "dark":
        mode = "dark";
        break;

      case "invert":
        if (mode === "dark") {
          mode = "light";
        } else {
          mode = "dark";
        }

        break;

      default:
        break;
    }

    return __spreadProps(__spreadValues({}, theme), {
      mode: mode
    });
  };
}, "setTheme");

var _ColorMode =
/* @__PURE__ */
__name(function (_ref9) {
  var mode = _ref9.mode,
      children = _ref9.children;
  return (
    /* @__PURE__ */
    import_react3.default.createElement(import_styled_components4.ThemeProvider, {
      theme: _setTheme(mode)
    }, children)
  );
}, "ColorMode"); // src/MaestroThemeProvider/GlobalStyle.tsx


var import_react4 = __toESM(require("react"));

var import_styled_components5 = require("styled-components");

var _canUseDOM =
/* @__PURE__ */
__name(function () {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}, "canUseDOM");

var _isBrowser = _canUseDOM();

var _useEnhancedEffect = _isBrowser ? import_react4.useLayoutEffect : import_react4.useEffect;

var GlobalStyleCSS = import_styled_components5.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    *,\n    *:before,\n    *:after {\n        box-sizing: inherit;\n    }\n\n    :root {\n        /* This variable is used by old webapp to adapt its layout */\n        --navbar-height: 64px;\n    }\n\n    :focus:not(:focus-visible) {\n        outline: 0;\n    }\n\n    html {\n        /* stylelint-disable */\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n        -moz-text-size-adjust: 100%;\n        -ms-text-size-adjust: 100%;\n        -webkit-text-size-adjust: 100%;\n        font-size: ", ";\n        box-sizing: border-box;\n    }\n\n    body {\n        color: ", ";\n        background-color: ", ";\n        font-family: ", ";\n        line-height: ", ";\n        font-size: ", ";\n        font-weight: ", ";\n    }\n\n    html,\n    body {\n        margin: 0;\n        padding: 0;\n        height: 100%;\n    }\n\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n        margin: 0;\n    }\n\n    figure {\n        margin: 0;\n        padding: 0;\n    }\n\n    /* Remove margin and padding */\n    ul,\n    ol,\n    li {\n        margin: 0;\n        padding: 0;\n        list-style: none;\n    }\n\n    /* Inherit typography settings */\n    input,\n    textarea,\n    select,\n    button {\n        font: inherit;\n        letter-spacing: inherit;\n    }\n\n    a {\n        color: ", ";\n    }\n\n    /* Remove extra styles for button */\n    button {\n        color: inherit;\n        border-radius: 0;\n        border: none;\n        background-color: transparent;\n    }\n\n    /* For JS interaction - Prevent the child of a button to be targeted */\n    button * {\n        pointer-events: none;\n    }\n\n    /* Default table styles */\n    table {\n        width: 100%;\n    }\n\n    [data-color-mode='light'] {\n        color: ", ";\n        background-color: ", ";\n\n        a {\n            color: ", ";\n        }\n    }\n\n    [data-color-mode='dark'] {\n        color: ", ";\n        background-color: ", ";\n\n        a {\n            color: ", ";\n        }\n    }\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.baseFontSize;
}, _color("text.base"), _color("background.base"), function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontFamily.base;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.lineHeights.base;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.baseFontSize;
}, _fontWeight("regular"), _color("text.base"), _color("neutral.900"), _color("neutral.0"), _color("neutral.900"), _color("neutral.50"), _color("neutral.1000"), _color("neutral.50"));
var InternalGlobalStyle = import_styled_components5.createGlobalStyle(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n    ", ";\n"])), GlobalStyleCSS);

var insertCssImports =
/* @__PURE__ */
__name(function (enabled) {
  if (document.getElementById("global-css-imports") || !enabled) {
    return;
  }

  var head = document.head || document.getElementsByTagName("head")[0];
  var styleElement = document.createElement("style");
  styleElement.id = "global-css-imports";
  head.insertBefore(styleElement, head.firstChild);
  styleElement.appendChild(document.createTextNode("\n            @import 'https://cdnjs.cloudflare.com/ajax/libs/normalize/8.0.1/normalize.min.css';\n            @import 'https://cdn.landr.com/fonts/Sailec/style.css';\n"));
}, "insertCssImports");

var _GlobalStyle =
/* @__PURE__ */
__name(function (_ref14) {
  var _ref14$withCssImports = _ref14.withCssImports,
      withCssImports = _ref14$withCssImports === void 0 ? true : _ref14$withCssImports;

  _useEnhancedEffect(function () {
    return insertCssImports(withCssImports);
  }, []);

  return (
    /* @__PURE__ */
    import_react4.default.createElement(InternalGlobalStyle, null)
  );
}, "GlobalStyle"); // Annotate the CommonJS export names for ESM import in node:


0 && (module.exports = {
  Breakpoints: _Breakpoints,
  ColorMode: _ColorMode,
  GlobalStyle: _GlobalStyle,
  MaestroThemeProvider: _MaestroThemeProvider,
  __DEV__: _DEV__,
  __TEST__: _TEST__,
  baseUnit: _baseUnit,
  border: _border,
  breakpoint: _breakpoint,
  canUseDOM: _canUseDOM,
  color: _color,
  component: _component,
  defaultTheme: _defaultTheme,
  fontSize: _fontSize,
  fontWeight: _fontWeight,
  get: _get,
  isBrowser: _isBrowser,
  isFunction: _isFunction,
  lineHeight: _lineHeight,
  opacity: _opacity,
  palette: _palette,
  radius: _radius,
  setTheme: _setTheme,
  shadow: _shadow,
  spacing: _spacing,
  stripUnit: _stripUnit,
  themeMode: _themeMode,
  token: _token,
  useEnhancedEffect: _useEnhancedEffect,
  useStyles: _useStyles,
  variant: _variant,
  zIndex: _zIndex
});